module.exports = __webpack_public_path__ + "media/lots.5218fd32.jpg";